import BaseListPresenter from "../../../base/BaseListPresenter";
import { dialog, Button } from "nq-component";

class PayrollTypePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 50;
    this.where = {
      "employmentType.id": { $ne: "c76600d3-99b6-4907-ac02-f66b30d1bfa1" },
    }
    this.search = {};
    this.filter = {};
    this.include = [
      "employmentType",
      "payrollRelation",
      "payrollRelation.classification",
    ];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { Firstname: 1, Middlename: 1, Surname: 1 };
    this.progress = true;
    this.preservedSelected = [];
    this.reset();
  }

  reset() {
    const getCurrentPage = localStorage.getItem("currentPage") || 1;
    this.objects = [];
    this.count = 0;
    this.current = Number(getCurrentPage) || 1;
    this.view.setObjects([]);
    this.view.setSelected(this.preservedSelected || []);
    this.view.setCount(0);
    this.view.setTotal(0);
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };

    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      // this.objects = this.objects.concat(objects);
      this.objects = objects;
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    // this.view.setSelected([]);
    this.findObjects();
  }
  onSelectAll(checked) {
    if (checked) {
      this.preservedSelected = [...this.objects];
      this.view.setSelected([...this.objects]);
    } else {
      this.preservedSelected = [];
      this.view.setSelected([]);
    }
  }

  onSelect(index) {
    const selectedObjects = this.view.state.selected;
    const selected = this.objects[index];
    const i = selectedObjects.findIndex((item) => item.id === selected.id);
    if (i > -1) {
      selectedObjects.splice(i, 1);
    } else {
      selectedObjects.push(selected);
    }
    this.preservedSelected = [...selectedObjects];
    this.view.setState({ selected: selectedObjects });
  }

  dialogClose() {
    dialog.close();
  }

  _onChangeFilter = async (type, value, field) => {
    try {
      const dataLists = await this.findObjectUseCase.execute(
        "payroll_relation",
        {
          keys: ["classification"],
          include: ["classification"],
          where: {
            "classification.id": value.id,
          },
        }
      );

      console.warn("dataLists", dataLists);

      const ids = dataLists.map((item) => item.id);
      const params = {
        type,
        value,
        field,
        ids,
      };

      this._getOnchangeFilter(params);
    } catch (error) {
      console.log("Error fetching data!", error);
    }
  };

  async filterSubmit(where) {
    const currentSelected = this.view.state.selected || [];
    if (currentSelected.length > 0) {
      this.preservedSelected = [...currentSelected];
    }
    localStorage.removeItem("currentPage");
    this.reset();
    this.filter = where;
    await this.getObjects();
    if (this.preservedSelected.length > 0) {
      this.view.setSelected([...this.preservedSelected]);
    }
  }

  _getOnchangeFilter = ({ type, value, fields, ids }) => {
    const where = { ...this.view.state.filters };
    switch (type) {
      case "Pointer": {
        if (value?.id) {
          where["payrollRelation"] = {
            $elemMatch: {
              id: { $in: ids },
            },
            // id: "9787597c-6da2-4cb2-bae0-de7641116f77",
          };
        } else {
          delete where["payrollRelation"];
        }
        break;
      }
      default:
        const field = fields;
        if (value) {
          where[field] = { $regex: value, $options: "i" };
        } else {
          delete where[field];
        }
    }
    this.view.setState({ filters: where }, () => {
      this.filterSubmit(this.view.state.filters);
    });
  };

  setSelectedEntries(params) {
    const { selected } = this.view.state;

    const entries = selected.map((entry) => {
      const { surname, Firstname, Middlename } = entry;
      return (
        <div
          style={{ fontSize: "13px" }}
          key={`${surname || " "}-${Firstname || " "}-${Middlename || " "}`}
        >
          {`${surname || " "} ${Firstname || " "} ${Middlename || " "}`}
        </div>
      );
    });
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row " style={{ textAlign: "center" }}>
            <p>
              <i
                className="bi bi-question-circle"
                style={{ color: "orange", fontSize: "20px" }}
              ></i>{" "}
              You are about to assign{" "}
              <b>
                {params?.selectedEarnings}
                {params?.selectedPayrollType &&
                  `-${params?.selectedPayrollType}`}
              </b>{" "}
              to
              <div className="mt-1">
                <b>{entries}</b>
              </div>
            </p>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, .65)",
              }}
            >
              Please click on OK to confirm changes.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              OK
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }
  async confirmChanges() {
    const { selected, selectedEarnings, selectedPayrollType, objects } =
      this.view.state;
    // const empIDs = selected.map((item) => item.id);

    if (selected.length > 0) {
      const updatePromises = selected.map(({ id }) => {
        const updateData = {
          id,
          earnings: selectedEarnings,
          payrollType: selectedPayrollType,
        };

        return this.upsertUseCase.execute("employees", updateData);
      });

      try {
        await Promise.all(updatePromises);
      } catch (error) {
        console.error("An error occurred while updating employees:", error);
      }
    } else {
      console.log("No employees found.");
    }
    this.view.setState({
      selectedEarnings: "",
      selectedPayrollType: "",
    });
    // this.dialogClose();
    // this.view.showSuccess("Successfully Assigned Payroll Type!");
    // this.view.refetchData();
    // this.current = this.view.state.current;
  }
}
export default PayrollTypePresenter;
